import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { DummyTimelineComponent } from "../../base/dummy-timeline/dummy-timeline.component";
import { FeatureFlagsService } from "../../../../services/internal-services/feature-flags.service";
import { GoogleAnalyticsService } from "../../../../../shared/services/google-analytics.service";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "app-dummy-projects-timeline",
  templateUrl: "./dummy-projects-timeline.component.html",
  styleUrls: ["../../base/dummy-timeline/dummy-timeline.component.scss"],
  standalone: false,
})
export class DummyProjectsTimelineComponent extends DummyTimelineComponent {
  constructor(
    googleAnalyticsService: GoogleAnalyticsService,
    cdr: ChangeDetectorRef,
    flagService: FeatureFlagsService,
  ) {
    super(googleAnalyticsService, cdr, flagService);
  }
}
